/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { Injectable } from '@angular/core';
import { RoutingService } from '@lm-nx-frontend/lm-inf-core';
import { Observable } from 'rxjs';
import { CurrentItemService } from '../../shared/current-item.service';
import {UserGroupService} from "../../../core/services";
import {ROUTE_PARAMS} from "../../../root/route-params";
import {UserGroup} from "../../../core/model";

@Injectable({
  providedIn: 'root',
})
export class CurrentUserGroupService extends CurrentItemService<UserGroup> {
  constructor(
    protected routingService: RoutingService,
    protected userGroupService: UserGroupService
  ) {
    super(routingService);
  }

  protected getParamKey() {
    return ROUTE_PARAMS.userGroupCode;
  }

  protected getItem(code: string): Observable<UserGroup> {
    return this.userGroupService.get(code);
  }

  getError(code: string): Observable<boolean> {
    return this.userGroupService.getErrorState(code);
  }
}
